import React, {memo} from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from "highcharts-react-official";
import 'highcharts/modules/annotations';

export default memo(function (props) {
    return (
        <div className="challenge-component-graph">
            <HighchartsReact
                highcharts={Highcharts}
                options={_.merge({}, {
                    annotationsOptions: {
                        enabledButtons: false
                    },
                    tooltip: {
                        headerFormat: '<b>{series.name}</b><br />',
                        pointFormat: 'x = {point.x}, y = {point.y}'
                    }
                }, props.component_data.data)}
            />
        </div>
    )
}, (oldProps, newProps) => oldProps.component_data.data === newProps.component_data.data)
